import React from "react";
import {
  Box,
  Container,
  Flex,
  Text,
  HStack,
  Link,
  Image,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import { useScroll } from "@/context/ScrollContext";

import SagaFiscalImage from "../assets/images/img/saga_fiscal_logo.webp";

export const Footer: React.FC = () => {
  const borderColor = useColorModeValue("gray.100", "gray.500");
  const textColor = useColorModeValue("gray.600", "gray.400");
  const linkColor = useColorModeValue("gray.600", "gray.300");
  const currentYear = new Date().getFullYear();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === "/";

  const { scrollToRef, benefitsRef } = useScroll();

  const mainNav = [
    { label: "Beneficios", href: "/#beneficios", action: () => isHome ? scrollToRef(benefitsRef) : navigate("/", { state: { scrollTo: "beneficios" } }) },
    { label: "FAQs",       href: "/faqs",        action: () => navigate("/faqs") },
    { label: "Contacto",   href: "/contactos",   action: () => navigate("/contactos") },
  ];

  const policyNav = [
    { label: "Términos y condiciones", href: "/docs/terminos-y-condiciones.pdf" },
    { label: "Soporte", href: "/contactos", onClick: () => navigate("/contactos") },
  ];

  return (
    <Box as="footer" py={6} mt="auto" w="100%" borderColor={borderColor} >
      <Container maxW="100%" px={8}>
        {/* TOP */}
        <Flex justify="space-between" align="center" mb={6} pt={5} >
          <Link as={RouterLink} to="/" mx={{ base: "auto", md: 0 }}>
            <Image
              src={SagaFiscalImage}
              alt="Saga Fiscal Logo"
              htmlWidth={480}
              htmlHeight={110}
              h={"31px"}
              objectFit="contain"
            />
          </Link>

          <HStack spacing={8} display={{ base: "none", md: "flex" }}>
            {mainNav.map((item) => (
              <Link
                key={item.label}
                href={item.href}
                fontSize="sm"
                color={linkColor}
                cursor="pointer"
                _hover={{ textDecoration: "none", opacity: 0.7 }}
                onClick={(e) => { e.preventDefault(); item.action(); }}
              >
                {item.label}
              </Link>
            ))}
          </HStack>
        </Flex>

        {/* BOTTOM */}
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align="center"
          gap={4}
          pt={6}
          borderTop="1px"
          borderColor={borderColor}
        >
          <HStack
            spacing={{ base: 4, md: 8 }}
            flexWrap="wrap"
            justify={{ base: "center", md: "flex-start" }}
          >
            {policyNav.map((item) => (
              <Link
                key={item.label}
                fontSize="sm"
                color={textColor}
                cursor="pointer"
                _hover={{ textDecoration: "underline" }}
                href={item.href}
                target={item.href?.endsWith(".pdf") ? "_blank" : undefined}
                rel={item.href?.endsWith(".pdf") ? "noopener noreferrer" : undefined}
                onClick={item.onClick ? (e) => { e.preventDefault(); item.onClick!(); } : undefined}
              >
                {item.label}
              </Link>
            ))}
            {/* Seguridad abre modal — no es un link navegable */}
            <Text
              as="button"
              fontSize="sm"
              color={textColor}
              cursor="pointer"
              _hover={{ textDecoration: "underline" }}
              onClick={onOpen}
            >
              Seguridad
            </Text>
          </HStack>

          <Text
            fontSize="sm"
            color={textColor}
            textAlign={{ base: "center", md: "right" }}
          >
            © {currentYear} Saga Fiscal. Todos los derechos reservados
          </Text>
        </Flex>
      </Container>

      <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
        <ModalOverlay />
        <ModalContent borderRadius="16px" p={2}>
          <ModalHeader fontSize="20px" fontWeight="700" color="gray.600">
            Seguridad
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={8}>
            <Text fontSize="16px" color="gray.600" lineHeight="1.7">
              SAGA Fiscal es una solución regida por un Sistema de Gestión de Seguridad de la Información (SGSI) alineado con los principios de la norma ISO/IEC 27001. El SGSI contempla la aplicación de controles y mejores prácticas para garantizar la confidencialidad, integridad y disponibilidad de la información de sus usuarios. SAGA Fiscal se ejecuta en la nube de Microsoft Azure con la aplicación de mejores prácticas en términos de almacenamiento seguro, encriptación punto a punto y gestión multicapa para asegurar altos niveles de seguridad.
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
